import { createContextHook } from '@/utils';
import { ChatContext, ChatInternalContext } from './ChatContext';

export const useChatContext = createContextHook(ChatContext);
export const useChatInternal = createContextHook(ChatInternalContext);
